<template>
    <div class="agent-page">
        <div class="page-header">
            <div style="display: flex; flex-direction: column; text-align: start;">
                <h2 class="page-title">{{ projectTitle }}</h2>
                <h2 class="page-title" style="margin-top: 10px;">合同管理</h2>
            </div>
            <div style="display: flex; gap: 12px;">
                <el-button type="primary" icon="el-icon-plus" @click="handleAdd">新增合同</el-button>
                <el-button type="primary" icon="el-icon-arrow-left" @click="handleBack">返回项目流程界面</el-button>
            </div>
        </div>
        <div class="table-section">
            <!-- 合同列表表格 -->
            <el-table :data="tableData" border style="width: 100% ;    margin-top: 10px;" v-loading="loading">
                <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
                <el-table-column prop="bidSectionName" label="标段名称" min-width="200"
                    show-overflow-tooltip></el-table-column>
                <el-table-column prop="tendererName" label="招标人名称" min-width="150"
                    show-overflow-tooltip></el-table-column>
                <el-table-column prop="winBidderName" label="中标人" min-width="150"
                    show-overflow-tooltip></el-table-column>
                <el-table-column prop="isSign" label="是否使用平台签章" width="150" align="center">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.isSign === 1 ? 'success' : 'info'" size="small">
                            {{ scope.row.isSign === 1 ? '是' : '否' }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="status" label="状态" width="100" align="center">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.status === 1 ? 'success' : 'warning'" size="small">
                            {{ scope.row.status === 1 ? '已提交' : '暂存' }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="150" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="handleView(scope.row)" v-if="scope.row.status === 1">查看</el-button>
                        <el-button type="text" size="small" @click="handleEdit(scope.row)"  v-if="scope.row.status != 1">编辑</el-button>
                        <el-button type="text" size="small" @click="handleDelete(scope.row)"
                            style="color: #F56C6C;">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <!-- 分页 -->
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNum"
                :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
                :total="total" style="margin-top: 20px; text-align: right;">
            </el-pagination>
        </div>
    </div>

</template>

<script>
import { contractAdd, getBidSectionList, contractDelete, contractDetail, contractInit, contractList } from '@/api/modules/contract'
import { loadProjectDetail } from '@/utils/bid/projectInfo'
export default {
    data() {
        return {
            projectTitle: '',
            projectCode: this.$route.query.projectCode,
            loading: false,
            tableData: [],
            pageNum: 1,
            pageSize: 10,
            total: 0
        }
    },
    mounted() {
        this.getProjectInfo()
        this.getContractList()
    },
    methods: {
        // 获取项目信息
        async getProjectInfo() {
            try {
                this.projectTitle = await loadProjectDetail(this.projectCode)
            } catch (error) {
                console.error('获取项目信息失败:', error)
            }
        },
        // 新增合同
        handleAdd() {
            this.$router.push({ name: 'contractAdd', query: { projectCode: this.projectCode } })

        },

        // 获取合同列表
        async getContractList() {
            this.loading = true
            try {
                const params = {
                    projectCode: this.projectCode,
                    pageNum: this.pageNum,
                    pageSize: this.pageSize
                }
                const res = await contractList(params)
                if (res.code === 200) {
                    this.tableData = res.data.records || []
                    this.total = res.data.total || 0
                } else {
                    this.$message.error(res.msg || '获取合同列表失败')
                }
            } catch (error) {
                console.error('获取合同列表失败:', error)
                this.$message.error('获取合同列表失败')
            } finally {
                this.loading = false
            }
        },

        // 查看合同详情
        handleView(row) {
            this.$router.push({ name: 'contractAdd', query: { contractCode: row.contractCode, projectCode: this.projectCode, handle: 'check' } })
        },

        // 编辑合同
        handleEdit(row) {
            console.log('编辑合同:', row)
            this.$router.push({ name: 'contractAdd', query: { contractCode: row.contractCode, projectCode: this.projectCode, handle: 'edit' } })
        },

        // 删除合同
        handleDelete(row) {
            this.$confirm('确定要删除该合同吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                try {
                    const res = await contractDelete({ contractCode: row.contractCode })
                    if (res.code === 200) {
                        this.$message.success('删除成功')
                        this.getContractList()
                    } else {
                        this.$message.error(res.msg || '删除失败')
                    }
                } catch (error) {
                    console.error('删除失败:', error)
                    this.$message.error('删除失败')
                }
            }).catch(() => { })
        },

        // 分页 - 每页数量变化
        handleSizeChange(val) {
            this.pageSize = val
            this.pageNum = 1
            this.getContractList()
        },

        // 分页 - 页码变化
        handleCurrentChange(val) {
            this.pageNum = val
            this.getContractList()
        },

        // 返回
        handleBack() {
            this.$router.go(-1)
        }
    }
}
</script>

<style lang="less" scoped>
@import '@/styles/minimal-gray-theme.less';

.agent-page {
    .apply-minimal-gray-theme();
}

.page-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-bottom: 20px;
    gap: 20px;

    .page-title {
        font-size: 16px;
        font-weight: 600;
        color: @gray-700;
        margin: 0;
        line-height: 1.5;
        position: relative;
        padding-left: 10px;

        &::before {
            content: '';
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            width: 3px;
            height: 16px;
            background: @gray-700;
            border-radius: 2px;
        }

        &:first-child::before {
            background: @primary-color;
        }
    }

    /deep/ .el-button {
        transition: all @transition-base ease;
        &:hover { transform: translateY(-1px); }
    }
}

.div {
    margin-top: 10px;
}
</style>
